import { React, useState } from 'react';
import { Modal } from 'antd';
import BaseAdminModal from '../../../../utility/AdminModal/view/BaseAdminModal';
const SystemHolidayModal = ({
    open = false,
    setOpen,
    propsLoading = null,
    onOk,
    data
}) => {
    const [loading, setLoading] = useState(false)

    return (
        <BaseAdminModal
            only_cancle={data?.total ? false : true}
            title="新增年度設置"
            open={open}
            confirmLoading={propsLoading === null ? loading : propsLoading}
            // cancelText={data?.total ? "取消" : "關閉"}
            okButtonProps={data?.total ? null : { hidden: true }}
            onCancel={() => setOpen(false)}
            onOk={() => {
                onOk();
            }}
        >
            {data?.total !== 0 ?
                <>
                    即將新增{data?.year}年度
                    <br />
                    共有{data?.total}天國定假日
                    <br />
                    確定要新增嗎？
                </>
                :
                `${data?.year}年度尚未有國定假日`
            }
        </BaseAdminModal>
    )
}
export default SystemHolidayModal;